/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliveryPointDto
 */
export interface DeliveryPointDto {
    /**
     * 
     * @type {string}
     * @memberof DeliveryPointDto
     */
    primaryReference: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPointDto
     */
    secondaryReference?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPointDto
     */
    tertiaryReference?: string;
}

/**
 * Check if a given object implements the DeliveryPointDto interface.
 */
export function instanceOfDeliveryPointDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "primaryReference" in value;

    return isInstance;
}

export function DeliveryPointDtoFromJSON(json: any): DeliveryPointDto {
    return DeliveryPointDtoFromJSONTyped(json, false);
}

export function DeliveryPointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryPointDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'primaryReference': json['primaryReference'],
        'secondaryReference': !exists(json, 'secondaryReference') ? undefined : json['secondaryReference'],
        'tertiaryReference': !exists(json, 'tertiaryReference') ? undefined : json['tertiaryReference'],
    };
}

export function DeliveryPointDtoToJSON(value?: DeliveryPointDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'primaryReference': value.primaryReference,
        'secondaryReference': value.secondaryReference,
        'tertiaryReference': value.tertiaryReference,
    };
}

